import { PendingApprovalsApiPath } from '../constants/pendingApprovalsApiConstants';

function requestPathWithoutQueryOrHash(requestUrl: string): string {
  const withoutQuery = requestUrl.split('?')[0] ?? requestUrl;
  return withoutQuery.split('#')[0] ?? withoutQuery;
}

/**
 * Returns false for background notification-bell polling so HTTP refetch does not
 * reset the session idle timer (@hsus-dev/session-policy recordActivity).
 */
export function shouldRecordSessionApiActivity(requestUrl: string | undefined): boolean {
  if (!requestUrl) return true;
  const path = requestPathWithoutQueryOrHash(requestUrl);
  return !PendingApprovalsApiPath.SUMMARY_PATH_PATTERN.test(path);
}
